import { ENDPOINTS } from "config/endpoints";
import { useMutation, useQueryClient } from "react-query";
import Error from "types/error";
import client from "utils/client";
import { Request } from "types/request";
import { Response } from "types/response";
import { generatePath } from "react-router-dom";

export default function useDeleteAcquistion() {
  const queryClient = useQueryClient();

  const deleteAcquistion = (id: string) => {
    const request: Request = {
      url: generatePath(ENDPOINTS.acquisitions.one, { id }),
      config: {
        method: "delete",
      },
    };
    return client(request);
  };

  const { data, mutate, ...rest } = useMutation<Response<null>, Error, string>(
    deleteAcquistion,
    {
      onSettled: (data, error, id) => {
        queryClient.invalidateQueries([ENDPOINTS.acquisitions.one, id]);
        queryClient.invalidateQueries([ENDPOINTS.acquisitions.all]);
      },
    }
  );

  return { data, mutate, ...rest };
}
